import { SearchAddress } from "./api/addressApi";

export const itemToString = (value?: SearchAddress) =>
  value?.AddressLine
    ? `${value.AddressLine}, ${value.Locality}, ${value.State}, ${value.Country}`
    : "";
